enum PagesPath {
    HOME = './Pages/Home',
    CONTACT = './Pages/Contact'
}

export default PagesPath;
